import { useQuery } from "@tanstack/react-query";
import { getDisplayAdjustments } from "@/services/firebase/displayMetric";

export const DISPLAY_ADJUSTMENTS_QUERY_KEY = ["display-adjustments"];

/** 全部劇的顯示數據調整量；CMS 統計用它把欄位值換算回真實值 */
export function useDisplayAdjustments() {
  return useQuery({
    queryKey: DISPLAY_ADJUSTMENTS_QUERY_KEY,
    queryFn: getDisplayAdjustments,
    staleTime: 30 * 1000,
  });
}
